<div id="page-content">
    <div class="container-fluid" style="background: linear-gradient(to top, rgba(0,0,0,0.7), transparent);height: 100%; padding: 0; padding-top: 50px;">
        <div class="row" style="padding: 0px 15px 10px;border-top: 1px solid rgb(255 255 255 / 25%);">
            <div class="col-12 p-0 d-flex flex-row justify-content-between">
            </div>
        </div>
        <mat-progress-bar mode="indeterminate" style="height: 3px; margin-top: 1px"></mat-progress-bar>
    </div>
</div>